import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { NavigationComponent } from '../navigation/navigation.component';
import { RibbonComponent } from './ribbon.component';

import { SessionSetting } from '../../../app.service';
import { KeycloakService } from '../../../keycloak.service';

declare var config: any;

@Component({
  selector: 'sa-route-breadcrumbs',
  template: `
        <!-- <ol class="breadcrumb">
           <li *ngFor="let item of items">{{item}}</li>
        </ol> -->
        <ol class="breadcrumb">
           <ng-container *ngFor="let menu of pathMenus">
              <li>{{menu.MENU_ID | ps_i18n:(menu.MENU_NAME)}}</li>\n
           </ng-container>
        </ol>
  `,
  styles: []
})
export class RouteBreadcrumbsComponent implements OnInit {

  public items: Array<string> = [];
  public pathMenus: any[] = [];
  private checkMenuCount = 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private kc: KeycloakService
  ) { }

  ngOnInit() {
    this.router.events
      .filter(e => e instanceof NavigationEnd)
      .subscribe((v: any) => {
        // this.items = [];
        // this.extract(this.router.routerState.root);

        if (v.url == "/login" || v.url == "/password") return;

        RibbonComponent.takeInButtonGroup(null);

        this.pathMenus = [];
        let path = v.urlAfterRedirects ? v.urlAfterRedirects : v.url;
        let menus = NavigationComponent.menuArray.filter(x => x.ACTION_PATH === path);
        this.checkInPathMenu(menus);

        if (this.pathMenus.length === 0) {
          if (path != "/home" && path != "/home/blank") {
            SessionSetting.setUser(null);
            if (config.devMode) {
              //this.router.navigate(['login']);
              location.href = "/";
            } else {
              this.kc.logout();
            }
            return;
          }
          let menuID = this.refineUrl(path, '/', '?');
          this.pathMenus.push({ MENU_ID: menuID });
        }
      });

    this.checkMenuCount = 0;
    this.checkMenu();
  }

  extract(route) {
    let pageTitle = route.data.value['pageTitle'];
    if (pageTitle && this.items.indexOf(pageTitle) === -1) {
      this.items.push(route.data.value['pageTitle'])
    }
    if (route.children) {
      route.children.forEach(it => {
        this.extract(it)
      })
    }
  }

  checkInPathMenu(menus: any[]) {
    let menu = menus.length > 0 ? menus[0] : null;
    if (menu) {
      let menus2 = NavigationComponent.menuArray.filter(v => v.MENU_ID === menu.PARENT_ID);
      this.checkInPathMenu(menus2);
      this.pathMenus.push(menu);
    }
  }

  checkMenu() {
    if (this.checkMenuCount > 5) {
      let menuID = this.refineUrl(location.href, '/#/', '?');
      this.pathMenus.push({ MENU_ID: menuID });
    } else if (NavigationComponent.menuArray.length === 0) {
      this.checkMenuCount++;
      setTimeout(() => this.checkMenu(), 1000);
    } else {
      let action = this.refineUrl(location.href, '/#', '?');
      let menus = NavigationComponent.menuArray.filter(x => x.ACTION_PATH === action);
      this.checkInPathMenu(menus);
      if (this.pathMenus.length === 0) {
        let menuID = this.refineUrl(action, '/', '?');
        this.pathMenus.push({ MENU_ID: menuID });
      }
    }
  }

  refineUrl(url: string, start: string, end: string) {
    let idx = url.indexOf(start);
    if (idx >= 0) url = url.substring(idx + start.length);
    idx = url.indexOf(end);
    if (idx >= 0) url = url.substring(0, idx);
    return url;
  }

}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/ribbon/route-breadcrumbs.component.ts